module.exports = __webpack_public_path__ + "img/central_park.f0c6ad7d.png";